import constants from '@playcastdotio/GlobalConfig';
import { addObservabilityHeaders } from '@playcastdotio/Observability';
import { getHostCorrelationIds } from '../../api/modules/realtime/hostCorrelation';

export type IceServerCredentials = {
  urls: string[];
  username: string;
  credential: string;
};

/**
 * Fetch TURN credentials from the public REST endpoint.
 * The server caches these for 5 minutes, so repeated calls are cheap.
 */
export async function fetchIceServersFromApi(): Promise<IceServerCredentials | null> {
  try {
    const ids = getHostCorrelationIds();
    const headers = addObservabilityHeaders(new Headers(), () => ids.machineId, () => ids.broadcastId);
    const response = await fetch(`${constants.REALTIME_API_BASE_URL}realtime/ice-servers`, { headers });
    if (!response.ok) return null;
    const data = await response.json();
    return data?.iceServers ?? null;
  } catch (err) {
    console.warn('[iceServerFetch] Failed to fetch ICE servers:', err);
    return null;
  }
}
